module.exports = __webpack_public_path__ + "static/media/Logo_VDL.20cc11d7.JPG";